export default class SavMail {
    constructor($view) {
        this.$view = $view;

        this.bind();
    }

    bind() {
        this.$view.on('click','.client-sav-mail-btn', function(e) {
            e.preventDefault();

            var element = $(this);
            let url = element.attr('href');

            $.ajax({
                url: url,
                success: function(answer) {
                    var icon = element.find('i');

                    if(icon.attr('class') == 'fas fa-bell'){
                        icon.attr('class','far fa-bell');

                        toastr.error('Notifications par email liées aux réclamations :  désactivées');
                    }else{
                        icon.attr('class','fas fa-bell');

                        toastr.success('Notifications par email liées aux réclamations :  activées');
                    }
                },
                error: function (data) {
                    toastr.error('Une erreur s\'est produite à l\'enregistrement de la modification !');
                }
            });
        });
    }
}